import PropTypes from "prop-types";
import { Button, Container, Modal } from "react-bootstrap";

const ConfirmModal = ({ show, data, content, onSubmitCallback }) => {
  const contentMessages = {
    header: {
      save: "ยืนยันการบันทึกข้อมูล",
      edit: "ยืนยันการบันทึกการเปลี่ยนแปลง",
      delete: "ยืนยันการลบข้อมูล",
      copy: "ยืนยันการคัดลอก",
      add: "ยืนยันการเพิ่มข้อมูล"
    },
    body: {
      save: "คุณกำลังจะบันทึกข้อมูลและเปลี่ยนแปลงข้อมูล\nหากยืนยันการบันทึกแล้วจะไม่สามารถข้อมูลเดิมนำกลับมาได้อีก",
      edit: "คุณกำลังจะบันทึกข้อมูลใหม่และบันทึกทับข้อมูลเดิม\nหากยืนยันการบันทึกแล้วจะไม่สามารถนำกลับมาได้อีก",
      delete:
        "คุณกำลังจะลบรายการที่เลือก\nหากยืนยันการลบแล้วจะไม่สามารถนำกลับมาได้อีก",
      copy: "คุณกำลังจะคัดลอกข้อมูล\nหากยืนยันการคัดลอกกรุณากดยืนยัน",
      add: "คุณกำลังจะเพิ่มข้อมูล\nหากยืนยันการเพิ่มข้อมูลให้กดปุ่มยืนยัน"
    }
  };

  return (
    <>
      <Modal show={show} centered>
        <Container fluid className="p-5">
          <Modal.Header className="p-2 justify-content-center border-bottom-0">
            <Modal.Title className="p-1">
              {contentMessages?.header?.[content]}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="px-0 text-center">
            <Modal.Title className="mb-0 fs-4 opacity-75">
              {contentMessages?.body?.[content].split("\n").map((line, idx) => (
                <span key={idx}>
                  {line}
                  <br />
                </span>
              ))}
            </Modal.Title>
          </Modal.Body>

          <Modal.Footer className="pt-3 justify-content-center border-top-0">
            <Button
              type="submit"
              variant="success"
              className="my-0 px-4 py-2 text-dark rounded-pill"
              onClick={(event) =>
                onSubmitCallback(event, {
                  dataCallback: data,
                  showCallback: !show
                })
              }
            >
              <Modal.Title className="px-2 fs-4">ยืนยัน</Modal.Title>
            </Button>
            <Button
              type="button"
              variant="outline-success"
              className="my-0 px-4 py-2 text-dark border-secondary rounded-pill"
              onClick={(event) =>
                onSubmitCallback(event, { showCallback: !show })
              }
            >
              <Modal.Title className="px-2 fs-4">ยกเลิก</Modal.Title>
            </Button>
          </Modal.Footer>
        </Container>
      </Modal>
    </>
  );
};

ConfirmModal.propTypes = {
  show: PropTypes.bool.isRequired,
  data: PropTypes.object,
  content: PropTypes.string,
  onSubmitCallback: PropTypes.func
};

export default ConfirmModal;
